export const TIME_RANGE_PARTS = [
  {
    key: 'year',
    group: 'date',
    label: 'Year',
    shortLabel: 'YEAR',
    settingsLabel: 'Year Datastream',
    fallbackMin: 0,
    fallbackMax: 9999,
    padLength: 4,
  },
  {
    key: 'month',
    group: 'date',
    label: 'Month',
    shortLabel: 'MONTH',
    settingsLabel: 'Month Datastream',
    fallbackMin: 1,
    fallbackMax: 12,
    padLength: 2,
  },
  {
    key: 'day',
    group: 'date',
    label: 'Day',
    shortLabel: 'DAY',
    settingsLabel: 'Day Datastream',
    fallbackMin: 1,
    fallbackMax: 31,
    padLength: 2,
  },
  {
    key: 'hours',
    group: 'time',
    label: 'Hours',
    shortLabel: 'HOUR',
    settingsLabel: 'Hours Datastream',
    fallbackMin: 0,
    fallbackMax: 23,
    padLength: 2,
    legacy: true,
  },
  {
    key: 'minutes',
    group: 'time',
    label: 'Min',
    shortLabel: 'MINUTE',
    settingsLabel: 'Minutes Datastream',
    fallbackMin: 0,
    fallbackMax: 59,
    padLength: 2,
    legacy: true,
  },
  {
    key: 'seconds',
    group: 'time',
    label: 'Sec',
    shortLabel: 'SECOND',
    settingsLabel: 'Seconds Datastream',
    fallbackMin: 0,
    fallbackMax: 59,
    padLength: 2,
  },
];

export const TIME_RANGE_PARTS_BY_KEY = TIME_RANGE_PARTS.reduce((acc, part) => {
  acc[part.key] = part;
  return acc;
}, {});

const getSafeDate = (value) => {
  const nextDate = value instanceof Date ? value : new Date(value);
  return Number.isNaN(nextDate.getTime()) ? new Date() : nextDate;
};

export const getCurrentTimeRangePartValues = (value = new Date()) => {
  const safeDate = getSafeDate(value);

  return {
    year: safeDate.getFullYear(),
    month: safeDate.getMonth() + 1,
    day: safeDate.getDate(),
    hours: safeDate.getHours(),
    minutes: safeDate.getMinutes(),
    seconds: safeDate.getSeconds(),
  };
};

export const getTimeRangePartFallbackValue = (partKey, value = new Date()) => {
  const partValues = getCurrentTimeRangePartValues(value);
  const part = TIME_RANGE_PARTS_BY_KEY[partKey];
  return partValues[partKey] ?? part?.fallbackMin ?? 0;
};

export const createDefaultTimeRangeStream = (partKey, value = new Date()) => ({
  deviceId: 0,
  dataId: null,
  pin: '',
  value: getTimeRangePartFallbackValue(partKey, value),
  enabled: true,
});

export const buildDefaultTimeRangeStreams = (value = new Date()) =>
  TIME_RANGE_PARTS.reduce((acc, part) => {
    acc[part.key] = createDefaultTimeRangeStream(part.key, value);
    return acc;
  }, {});

export const isTimeRangePartEnabled = (partKey, stream) => {
  if (typeof stream?.enabled === 'boolean') {
    return stream.enabled;
  }

  if (TIME_RANGE_PARTS_BY_KEY[partKey]?.legacy) {
    return true;
  }

  return Boolean(stream);
};
